import CampaignModel from 'cio/models/campaign';

export enum ExitCondition {
  GoalMet = 'goal-met',
  NoExit = 'no-exit',
  /* eslint-disable-next-line spellcheck/spell-checker */
  UnmatchTrigger = 'unmatch-trigger',
  /* eslint-disable-next-line spellcheck/spell-checker */
  GoalMetOrUnmatchTrigger = 'goal-met-or-unmatch-trigger',
}

export function selectedExitCondition(
  campaign: Pick<CampaignModel, 'exitOnTriggerOrFilterNotMatched' | 'exitOnConversionMatched'>,
) {
  let { exitOnTriggerOrFilterNotMatched, exitOnConversionMatched } = campaign;

  // default state, none selected (rather than both false which means they don't exit the campaign)
  if (exitOnConversionMatched == null && exitOnTriggerOrFilterNotMatched == null) {
    return null;
  } else if (exitOnConversionMatched && exitOnTriggerOrFilterNotMatched) {
    return ExitCondition.GoalMetOrUnmatchTrigger;
  } else if (exitOnConversionMatched && !exitOnTriggerOrFilterNotMatched) {
    return ExitCondition.GoalMet;
  } else if (!exitOnConversionMatched && exitOnTriggerOrFilterNotMatched) {
    return ExitCondition.UnmatchTrigger;
  } else if (!exitOnConversionMatched && !exitOnTriggerOrFilterNotMatched) {
    return ExitCondition.NoExit;
  }

  return null;
}
